export default __webpack_public_path__ + "static/media/register-slide-4.96e09f46.jpg";